import { render, staticRenderFns } from "./dialog-use-terms.vue?vue&type=template&id=365bffd1&scoped=true"
import script from "./dialog-use-terms.vue?vue&type=script&lang=js"
export * from "./dialog-use-terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365bffd1",
  null
  
)

export default component.exports